import { render, staticRenderFns } from "./RoofSelection.vue?vue&type=template&id=6981920c&scoped=true&"
import script from "./RoofSelection.vue?vue&type=script&lang=js&"
export * from "./RoofSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6981920c",
  null
  
)

export default component.exports